import { Formik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../shared/hook";
import { format } from "date-fns";
import { FaInfoCircle } from "react-icons/fa";
import style from "./ProfileCard.module.css";

function ProfileCard() {
  const { t, i18n } = useTranslation();
  const [initialValues, setInitialValues] = useState<any>(null);
  const [userFilesData, setUserFilesData] = useState([]);
  const userData: any = useAppSelector((state) => state.auth.userData);
  
  // Получаем роли из userData
  const userRoles = userData?.roles || [];

  // Функция для определения цвета плашки роли
  const getRoleChipClass = useCallback((roleName: string) => {
    const n = (roleName || "").toLowerCase();
    if (n.includes("админ")) return "bg-purple-100 text-purple-800";
    if (n.includes("менедж")) return "bg-emerald-100 text-emerald-800";
    if (n.includes("инженер")) return "bg-sky-100 text-sky-800";
    if (n.includes("оператор")) return "bg-indigo-100 text-indigo-800";
    return "bg-gray-100 text-gray-700";
  }, []);






  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => { }}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={true}
    >
      {(formik) => (
        <div className="w-full flex flex-col font-['Inter'] mt-[20px]">
          <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px]">
            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
              <img src="assets/orgData.png" className="w-[20px]" />
              <div className="uppercase">
                {t("profile_card.organization_title")}
              </div>
            </div>
            <div className="flex flex-col gap-[30px]">
              {/* Первый ряд - 5 полей */}
              <div className="flex gap-x-[100px] gap-y-[20px] items-center text-base">
                <div className="text-gray-600 w-[300px] font-semibold">
                  {t("profile_card.organization_name")}
                  <p className="text-gray-600 font-light">
                    {[
                      userData?.lastName || userData?.lastname,
                      userData?.firstName || userData?.firstname,
                      userData?.secondName || userData?.secondname
                    ]
                      .filter(Boolean)
                      .join(" ") || "-"}
                  </p>
                </div>
                <div className="text-gray-600 w-[300px] font-semibold">
                  {t("profile_card.organization_iin_bin")}
                  <p className="text-gray-600 font-light">
                    {userData?.login || "-"}
                  </p>
                </div>
                <div className="text-gray-600 w-[300px] font-semibold">
                  {t("profile_card.organization_phone")}
                  <p className="font-light">
                    {userData?.phone || "-"}
                  </p>
                </div>
                <div className="text-gray-600 w-[300px] font-semibold">
                  {t("profile_card.organization_email")}
                  <p className="font-light">
                    {userData?.email || "-"}
                  </p>
                </div>
                <div className="text-gray-600 w-[300px] font-semibold">
                  <div className={style.tooltipWrapper}>
                    {t('profile_card.registration_date')}
                    <FaInfoCircle className={style.errorIcon} />
                    <div className={style.tooltipText}>
                      {t('profile_card.registration_date_tooltip')}
                    </div>
                  </div>
                  {userData?.createdAt ? (
                    <p className="text-gray-600 font-light">
                      {format(new Date(userData.createdAt), 'dd.MM.yyyy HH:mm:ss')}
                    </p>
                  ) : (
                    '-'
                  )}
                </div>
              </div>
              
              {/* Второй ряд - роли отдельно */}
              <div className="text-gray-600 w-full font-semibold">
                {t("profile_card.role")}:
                <div className={style.rolesList}>
                  {userRoles.length > 0 ? (
                    userRoles.map((role: any, index: number) => {
                      const roleName = role?.nameRu || role?.nameEn || "-";
                      const chipClass = getRoleChipClass(roleName);
                      return (
                        <span 
                          key={role?.id || index} 
                          className={`px-2.5 py-[3px] rounded-full text-[12px] font-medium ${chipClass}`}
                        >
                          {roleName}
                        </span>
                      );
                    })
                  ) : (
                    <p className="text-gray-600 font-light">-</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
}

export default ProfileCard;
